import { j as l } from "../../../jsx-runtime-ClSzPYp4.js";
import r from "../../StyledPath.mjs";
const h = ({ primaryColor: e = "very.pink500", secondaryColor: t = "global.white", id: o = "veryLogo", label: a = "Very logo", ...s }) => /* @__PURE__ */ l.jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 150 150",
  "aria-labelledby": o,
  ...s,
  children: [
    /* @__PURE__ */ l.jsx("title", {
      id: o,
      children: a
    }),
    /* @__PURE__ */ l.jsx(r, {
      fillColor: e,
      d: "M150 150H0L.07 16.41 0 0h150v150z"
    }),
    /* @__PURE__ */ l.jsx(r, {
      fillColor: t,
      d: "M131 56.3c-.42 4-2.22 16.83-8.78 27l-11.61-27.15c-10.32-.57-16 3.63-18 5.78 0-1.42-2.16-4.42-3.3-5.12l-6.07 4.12c4 3.71 3.82 9.8 3.82 12.71v16.64h7.64V73.36c0-4.26 2.67-8.2 10.59-9.54l11.21 26.25a25.2 25.2 0 0 1-11 5.85l1.85 7.69c12.1-2.93 21.42-12.3 27-27.09a81 81 0 0 0 4.61-20.22ZM40.15 55.44 27.73 83.73C20 72.52 19.15 58.06 19.08 56.3h-7.89a68.08 68.08 0 0 0 4 20.23 51.19 51.19 0 0 0 7.32 13.75h11.11L47.4 58.55ZM65.06 55.7c-10.94 0-17.93 8.35-17.93 18 0 10.26 7.13 18.11 18.29 18.11 7.44 0 12-2.69 15.73-7.44L75.1 80a11.36 11.36 0 0 1-9.26 4.44c-5.29 0-9-2.76-10.1-7.64h26a16.05 16.05 0 0 0 .41-3.8c0-9.72-6.42-17.3-17.09-17.3Zm-9.32 14.79c1.13-4.67 4.73-7.28 9.68-7.28 4.52 0 7.69 2.19 8.4 7.28Z"
    })
  ]
});
export {
  h as default
};
